import { render, staticRenderFns } from "./seniorDismissalStatus.vue?vue&type=template&id=766c8acc"
import script from "./seniorDismissalStatus.vue?vue&type=script&lang=js"
export * from "./seniorDismissalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766c8acc')) {
      api.createRecord('766c8acc', component.options)
    } else {
      api.reload('766c8acc', component.options)
    }
    module.hot.accept("./seniorDismissalStatus.vue?vue&type=template&id=766c8acc", function () {
      api.rerender('766c8acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalStatus.vue"
export default component.exports